let swipers = {
    contentSlider: {
        slider: false,
        elem: $('.js-article-content-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            centerInsufficientSlides: true,
            pagination: {
                el: '.js-article-content-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-article-content-slider-next',
                prevEl: '.js-article-content-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.contentSlider.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    }
}

Event.on('Window.resized', function() {
    checkSliders(swipers);
});

$(function() {
    checkSliders(swipers);

    $("form[name=blog-subscription]").on("submit", e => {
        ga("send", {
            hitType: 'event',
            eventCategory: 'Form',
            eventAction: 'send',
            eventLabel: 'newsletterForm'
        });
    });
});